<template>
  <div>
    <v-dialog
      v-model="loading"
      persistent
      fullscreen
      transition="fade-transition"
      content-class="d-flex align-center justify-center"
      overlay-color="black"
      overlay-opacity="0.3"
    >
      <v-card
        color="transparent"
        flat
        class="d-flex align-center justify-center"
      >
        <v-progress-circular color="#D32F2F" indeterminate size="100" />
      </v-card>
    </v-dialog>

    <v-dialog v-model="alert.value" max-width="500">
      <v-card>
        <v-alert
          v-model="alert.value"
          :type="alert.type"
          variant="tonal"
          border="bottom"
        >
          {{ $t(alert.message) }}
        </v-alert>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addEbayModal" persistent width="auto">
      <v-card class="pa-3">
        <v-alert
          :model-value="true"
          variant="tonal"
          border="bottom"
          type="success"
        >
          <strong> {{ $t("parts.inventory.want_to_add_ebay") }}?</strong>
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn
            small
            variant="outlined"
            color="green-darken-2"
            @click="acceptAddEbay()"
          >
            {{ $t("parts.inventory.yes") }}
          </v-btn>
          <v-btn
            small
            variant="outlined"
            color="red-darken-2"
            @click="cancelAddEbay()"
          >
            {{ $t("parts.inventory.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addEbayInternationalModal" persistent width="auto">
      <v-card class="pa-3">
        <v-alert
          :model-value="true"
          variant="tonal"
          border="bottom"
          type="success"
        >
          <strong>
            {{ $t("parts.inventory.want_to_add_ebay") }}.{{ site }}?</strong
          >
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn
            small
            variant="outlined"
            color="green-darken-2"
            @click="acceptAddEbayInternational()"
          >
            {{ $t("parts.inventory.yes") }}
          </v-btn>
          <v-btn
            small
            variant="outlined"
            color="red-darken-2"
            @click="cancelAddEbayInternational()"
          >
            {{ $t("parts.inventory.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteEbayModal" persistent width="400">
      <v-card class="pa-3">
        <strong> {{ $t("parts.inventory.want_to_delete_ebay") }}</strong>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn
            small
            variant="outlined"
            color="green-darken-2"
            @click="deleteAllListings()"
          >
            {{ $t("parts.inventory.yes") }}
          </v-btn>
          <!-- <v-btn
            small
            @click="acceptDeleteEbay()"
          >
            {{ $t('parts.inventory.yes') }}
          </v-btn> -->
          <v-btn
            small
            variant="outlined"
            color="red-darken-2"
            @click="cancelDeleteEbay()"
          >
            {{ $t("parts.inventory.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="successAddEbayModal" persistent width="400">
      <v-card class="pa-3">
        <v-alert :value="true" type="success">
          <strong> {{ $t("parts.inventory.success_ebay") }}</strong>
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="successAddEbay()"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorEbayModal" persistent width="400">
      <v-card class="pa-3">
        <v-alert :value="true" type="error" variant="tonal" border="bottom">
          <strong>
            {{
              errorMsg
                ? ebayErrorText(errorMsg)
                : $t("parts.inventory.error_ebay")
            }}</strong
          >
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn variant="outlined" @click="errorEbay()"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addItemResponseModal" persistent width="400">
      <v-card class="pa-3">
        <div v-for="(item, index) in addItemResponse" :key="index">
          <v-alert
            :value="true"
            :type="item.errorMsg ? 'error' : 'success'"
            variant="tonal"
            border="bottom"
            class="mb-2"
          >
            <strong>
              {{
                item.errorMsg
                  ? ebayErrorText(item.errorMsg)
                  : `Item with eBay ID ${item.lekoItem ? item.lekoItem : item.ebayId} - Success!`
              }}</strong
            >
          </v-alert>
        </div>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn variant="outlined" @click="closeAddItemResponseModal()">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alreadyOnEbayModal" persistent width="500">
      <v-card class="pa-3">
        <v-alert
          v-for="(item, index) in onEbay"
          :key="index"
          :value="true"
          type="warning"
        >
          <strong>
            {{
              item.infoCar &&
              item.infoCar.description &&
              item.infoCar.description.descriptionId &&
              item.infoCar.description.descriptionId.title
                ? item.infoCar.description.descriptionId.title.it
                : ""
            }}
          </strong>
          {{ $t("parts.inventory.already_on_ebay") }}
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="closeAlreadyEbay()"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ebayMultipleDialog" persistent width="500">
      <v-card class="pa-3">
        <v-alert
          v-for="(item, index) in ebayResponse"
          :key="index"
          :value="true"
          :type="item.errorMsg ? 'error' : 'success'"
          variant="tonal"
          border="bottom"
          class="mb-2"
        >
          <strong>
            {{ item.lekoItem }}
          </strong>
          {{
            item.errorMsg
              ? ebayErrorText(item.errorMsg)
              : $t("parts.inventory.success_ebay")
          }}
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="closeEbayMultiple()"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ebayRemoveMultipleDialog" persistent width="500">
      <v-card class="pa-3">
        <v-alert
          v-for="(item, index) in ebayResponse"
          :key="index"
          :value="true"
          :type="item.errorMsg ? 'error' : 'success'"
          variant="tonal"
          border="bottom"
          class="mb-2"
        >
          <strong>
            {{ item.lekoItem }}
          </strong>
          {{
            item.errorMsg
              ? ebayErrorText(item.errorMsg)
              : $t("parts.inventory.success_deleted_ebay")
          }}
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="ebayRemoveMultipleDialog = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="acceptAddMultipleEbayDialog" persistent width="auto">
      <v-card class="pa-3">
        <v-col cols="12">
          <div>
            <v-chip
              v-for="part in multipleItems"
              :key="part._id"
              closable
              color="green-darken-2"
              class="ma-1"
              @click:close="removePart(part)"
            >
              {{ part.old_id.slice(-6) }}
            </v-chip>
          </div>
        </v-col>
        <v-alert
          :model-value="true"
          variant="tonal"
          border="bottom"
          type="success"
        >
          <strong>
            {{ $t("parts.inventory.want_to_add_multiple_ebay") }}</strong
          >
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn
            small
            variant="outlined"
            color="green-darken-2"
            @click="acceptAddMultipleEbay()"
          >
            {{ $t("parts.inventory.yes") }}
          </v-btn>
          <v-btn
            small
            variant="outlined"
            color="red-darken-2"
            @click="cancelEbayMultiple()"
          >
            {{ $t("parts.inventory.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="kTypesDialog" persistent width="350">
      <v-toolbar flat style="background-color: #d32f2f">
        <v-toolbar-title>
          {{ $t("parts.inventory.ktype_codes") }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          size="small"
          color="white"
          @click="closeKtypesDialog"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="pa-3" height="400" style="overflow: scroll">
        <div class="col-12 text-center" style="display: ruby">
          <v-card
            v-for="(item, index) in kTypes"
            :key="index"
            width="75"
            class="mb-2"
          >
            {{ item }}
          </v-card>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editEbayTitleModal" persistent width="auto">
      <v-toolbar flat dark style="background-color: #d32f2f">
        <v-toolbar-title>{{
          $t("parts.inventory.ebay_title")
        }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          size="small"
          color="white"
          @click="closeEditEbayTitleDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <div class="pa-3">
          <v-text-field
            v-model="ebayTitle"
            variant="solo"
            :maxlength="73"
            :label="$t('parts.table.ebay_title')"
            color="red-darken-1"
            @input="validateInput"
          >
            <template #append>
              <div class="qr-code-box">
                {{ qrCode }}
              </div>
            </template>
          </v-text-field>
          <div class="col-12 grey--text">
            <small class="d-flex text-end justify-end"
              >{{ $t("parts.inventory.ebay_qr_condition") }}***</small
            >
          </div>
        </div>
        <div class="pb-3 pl-3 pr-3">
          <v-alert
            :value="true"
            type="error"
            border="bottom"
            variant="outlined"
            class="pa-2"
          >
            {{ $t("parts.inventory.ebay_title_alert") }}
          </v-alert>
        </div>
        <v-card-actions class="col-12 justify-end mt-2 pb-4">
          <v-btn small variant="outlined" @click="closeEditEbayTitleDialog()">
            {{ $t("close") }}
          </v-btn>
          <v-btn
            small
            color="#D32F2F"
            class="white--text"
            variant="outlined"
            :disabled="!ebayTitle"
            @click="acceptEditEbayTitle()"
          >
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ebayLinksModal" temporary width="auto ">
      <v-card width="auto">
        <v-toolbar flat dark style="background-color: #d32f2f">
          <v-toolbar-title>
            <h4 class="text-white">
              <strong>
                {{ itemTitle }} - {{ $t("parts.inventory.see_ebay") }}</strong
              >
            </h4>
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            variant="outlined"
            icon
            size="x-small"
            color="white"
            class="ml-2"
            @click="closeEbaylinks()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="d-flex flex-wrap pa-2">
          <div
            v-if="!ebayItems.it || ebayItems.it.length == 0"
            class="pa-2 text-center"
          >
            <hr />
            <img :src="getImg('it')" width="20" class="pt-1" />
            &nbsp;&nbsp;&nbsp; eBay<strong>.it</strong>

            <div class="mt-2">
              <v-btn
                color="green"
                style="text-transform: none !important; color: white"
                @click="openAddEbay(selectedItem)"
              >
                {{ $t("parts.inventory.add_ebay") }}.it
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <div
            v-for="(itemList, countryCode) in ebayItems"
            :key="countryCode"
            class="d-flex flex-wrap align-items-start"
          >
            <div
              v-if="itemList && itemList.length > 0"
              class="pa-2 text-center"
            >
              <div>
                <hr />
                <img :src="getImg(countryCode)" width="20" class="pt-1" />
                &nbsp;&nbsp;&nbsp; eBay<strong
                  >.{{ countryCode === "uk" ? "com" : countryCode }}</strong
                >
              </div>

              <div
                v-for="(item, itemIndex) in itemList"
                :key="item"
                class="pa- border-bottom text-center"
                :style="{
                  backgroundColor: itemIndex % 2 === 0 ? '#ededed' : '',
                }"
              >
                <strong class="pa-1">{{ itemIndex + 1 }}.</strong>

                <a
                  target="_blank"
                  role="button"
                  class="pa-3 underline d-inline-block"
                  style="color: #1174d0; text-decoration: underline"
                  @click="openEbayLink(countryCode, item)"
                >
                  {{ $t("parts.inventory.open_link") }} - {{ item.slice(-4) }}
                  <v-icon size="small" color="#1174d0"
                    >mdi-arrow-top-right</v-icon
                  >
                </a>
                <v-icon
                  color="red"
                  @click="deleteIndividual(item, countryCode)"
                >
                  mdi-delete
                </v-icon>
              </div>

              <div>
                <v-btn
                  variant="outlined"
                  color="red"
                  style="text-transform: none !important"
                  class="mt-2"
                  @click="deleteAllByCountry(countryCode)"
                >
                  {{ $t("parts.inventory.delete_from_ebay") }}.{{
                    countryCode === "uk" ? "com" : countryCode
                  }}
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </div>

          <div
            v-for="country in countriesToShow.filter(
              (c) =>
                (!ebayItems[c] || ebayItems[c].length == 0) &&
                $store.getters.institutionEbayInternational[c],
            )"
            v-if="!ebayItems[country] || ebayItems[country].length == 0"
            :key="'add-' + country"
            class="pa-2 text-center"
          >
            <hr />
            <img :src="getImg(country)" width="20" class="pt-1" />
            &nbsp;&nbsp;&nbsp; eBay<strong>.{{ country }}</strong>

            <div class="mt-2">
              <v-btn
                color="green"
                style="text-transform: none !important; color: white"
                @click="openAddEbayInternational(selectedItem, country)"
              >
                {{ $t("parts.inventory.add_ebay") }}.{{ country }}
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import getRequest from "../../api/getRequest";
import {
  coerceEbayErrorPayload,
  translateEbayErrorMessage,
} from "../../utils/ebayErrorMessages";

export default {
  components: {},
  data: () => ({
    carData: null,
    xmlData: null,
    successAddEbayModal: false,
    errorEbayModal: false,
    addEbayModal: false,
    deleteEbayModal: false,
    alert: {
      value: false,
      type: "success",
      message: "",
    },
    alreadyOnEbayModal: false,
    onEbay: [],
    ebayResponse: null,
    ebayMultipleDialog: false,
    loading: false,
    multipleItems: [],
    acceptAddMultipleEbayDialog: false,
    ebayRemoveMultipleDialog: false,
    errorMsg: null,
    kTypesDialog: false,
    editEbayTitleModal: false,
    ebayTitle: null,
    qrCode: null,
    itemToEdit: null,
    kTypes: [],
    ebayLinksModal: false,
    ebayItems: {},
    itemTitle: null,
    selectedItem: null,
    addItemResponseModal: false,
    addItemResponse: [],
    addEbayInternationalModal: false,
    site: "",
    // baseUrl: "http://localhost:3000",
    baseUrl: "https://api.lekotech.com",
    countriesToShow: [],
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
  },
  watch: {
    ebayTitle(newValue) {
      if (newValue) {
        let title = newValue.slice(0, 73);
        const lastSixChars = newValue.slice(-6);
        if (lastSixChars === this.qrCode) {
          title = newValue.slice(0, -6).trim();
        }
        this.ebayTitle = title;
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    errorEbay() {
      this.errorEbayModal = false;
    },
    closeAddItemResponseModal() {
      this.addItemResponseModal = false;
      this.addItemResponse = [];
      this.ebayLinksModal = false;
      this.ebayItems = {};
      this.selectedItem = null;
      this.countriesToShow = [];
      this.$emit("close");
    },
    successAddEbay() {
      this.successAddEbayModal = false;
      this.close();
    },
    acceptDeleteEbay() {
      this.loading = true;
      axios
        .get(
          `${this.baseUrl}/ebay/delete-item/${this.ebayItem._id}?institutionId=${this.$store.getters.institutionId}`,
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((res) => {
          if (res) {
            this.loading = false;
            this.deleteEbayModal = false;
            this.alert = {
              value: true,
              type: "success",
              message: "parts.inventory.successfully_removed_ebay",
            };
            setTimeout(() => {
              this.alert.value = false;
            }, 3000);
            this.carData = null;
            this.xmlData = null;
            this.ebayItem = null;
            this.$emit("close");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.deleteEbayModal = false;
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.errorMsg
          ) {
            this.errorMsg =
              coerceEbayErrorPayload(err.response.data) ||
              err.response.data.errorMsg;
            this.errorEbayModal = true;
          }
        })
        .finally(() => {
          this.deleteEbayModal = false;
          this.loading = false;
          this.$emit("close");
        });
    },
    endItemEbay(item) {
      axios
        .get(
          `${this.baseUrl}/ebay/delete-item/${item._id}?institutionId=${this.$store.getters.institutionId}`,
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((res) => {
          if (res) {
            this.$emit("close");
            return res;
          }
        })
        .catch((err) => err.response.data);
    },
    cancelDeleteEbay() {
      this.deleteEbayModal = false;
    },
    acceptAddEbay(item) {
      let itemToSend = null;
      if (item) {
        itemToSend = item;
      } else {
        itemToSend = this.ebayItem;
      }
      this.addEbayModal = false;
      this.loading = true;
      axios
        .get(
          `${this.baseUrl}/ebay/add-item/${itemToSend._id}?institution_id=${this.$store.getters.institutionId}`,
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((res) => {
          if (res && res.data) {
            this.addItemResponse = this.parseAddItemApiResponse(res.data);
            this.addItemResponseModal = true;
            this.$emit("close");
          }
        })
        .catch((err) => {
          this.loading = false;
          if (err) {
            this.errorMsg = null;
            this.errorEbayModal = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close");
        });
    },
    cancelAddEbay() {
      this.addEbayModal = false;
    },
    async openAddEbay(item) {
      if (this.hasPositionMismatchForEbay(item)) {
        this.showPositionMismatchEbayError();
        return;
      }
      this.carData = null;
      this.xmlData = null;
      this.ebayItem = item;
      if (item.car_id) {
        await this.getCarData(item.car_id);
      }
      this.addEbayModal = true;
    },
    async openAddEbayInternational(item, site) {
      if (this.hasPositionMismatchForEbay(item)) {
        this.showPositionMismatchEbayError();
        return;
      }
      this.carData = null;
      this.xmlData = null;
      this.ebayItem = item;
      this.site = site;
      if (item.car_id) {
        await this.getCarData(item.car_id);
      }
      this.addEbayInternationalModal = true;
    },
    acceptAddEbayInternational(item) {
      this.ebayLinksModal = false;
      let itemToSend = null;
      if (item) {
        itemToSend = item;
      } else {
        itemToSend = this.ebayItem;
      }
      this.addEbayInternationalModal = false;
      this.loading = true;
      axios
        .get(
          `${this.baseUrl}/ebay/add-item/${itemToSend._id}?institution_id=${this.$store.getters.institutionId}&site=${this.site}`,
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((res) => {
          if (res && res.data) {
            this.addItemResponse = this.parseAddItemApiResponse(res.data);
            this.ebayItem = res.data.item;
            this.addItemResponseModal = true;
            this.$emit("close");
          }
        })
        .catch((err) => {
          this.loading = false;
          if (err) {
            this.errorMsg = null;
            this.errorEbayModal = true;
          }
        })
        .finally(() => {
          this.$emit("close");
          this.site = "";
          this.loading = false;
        });
    },
    cancelAddEbayInternational() {
      this.addEbayInternationalModal = false;
    },
    async getCarData(id) {
      await getRequest("/car/", `id=${id}`)
        .then((response) => {
          this.carData = response.car;
        })
        .catch(() => {});
    },
    openDeleteEbay(item) {
      this.ebayItem = item;
      this.selectedItem = item;
      this.deleteEbayModal = true;
    },
    hasPositionMismatchForEbay(item) {
      const mismatches = item?.alerts?.mismatches;
      if (!Array.isArray(mismatches)) return false;
      return mismatches.some(
        (m) =>
          m?.field === "position" &&
          m?.type === "error" &&
          m?.reason === "position_mismatch",
      );
    },
    showPositionMismatchEbayError() {
      this.errorMsg = this.$t("parts.inventory.ebay_position_mismatch");
      this.errorEbayModal = true;
    },
    ebayErrorText(msg) {
      const raw = coerceEbayErrorPayload(msg);
      if (!raw) return "";
      return translateEbayErrorMessage(raw, (key, values) =>
        this.$t(key, values || {}),
      );
    },
    parseAddItemApiResponse(data) {
      if (!data) return [];
      if (data.errorMsg) return [{ errorMsg: data.errorMsg }];
      if (Array.isArray(data) && data[0]?.response) {
        const inner = data[0].response;
        return Array.isArray(inner) ? inner : [inner];
      }
      return Array.isArray(data) ? data : [data];
    },
    addMultipleEbayItems(items) {
      // Check if more than 5 items are selected
      if (items.length > 5) {
        this.alert = {
          value: true,
          type: "error",
          message: "parts.inventory.max_5_items",
        };
        setTimeout(() => {
          this.alert.value = false;
        }, 5000);
      } else {
        if (items.some((item) => this.hasPositionMismatchForEbay(item))) {
          this.showPositionMismatchEbayError();
          return;
        }
        items.forEach((item) => {
          if (item.eBayStatus === true) {
            this.onEbay.push(item);
          }
        });
        if (this.onEbay.length > 0) {
          this.alreadyOnEbayModal = true;
        } else {
          this.multipleItems = items;
          this.acceptAddMultipleEbayDialog = true;
        }
      }
    },
    deleteMultipleEbayItems(items) {
      if (items.length > 5) {
        this.alert = {
          value: true,
          type: "error",
          message: "parts.inventory.max_5_items_delete",
        };
        setTimeout(() => {
          this.alert.value = false;
        }, 5000);
        return;
      } else {
        const itemIds = items.map((item) => item._id);

        this.loading = true;
        axios
          .post(
            `${this.baseUrl}/ebay/delete-items`,
            { ids: itemIds, institutionId: this.$store.getters.institutionId },
            {
              headers: { authorization: localStorage.token },
            },
          )
          .then((response) => {
            this.loading = false;
            this.ebayResponse = response.data;
            this.ebayRemoveMultipleDialog = true;
            this.multipleItems = [];
            this.$emit("close");
          })
          .catch((error) => {
            this.loading = false;
            this.multipleItems = [];
            this.alert = {
              value: true,
              type: "error",
              message: "parts.inventory.error_deleting_items",
            };
            setTimeout(() => {
              this.alert.value = false;
            }, 5000);
          })
          .finally(() => {
            this.loading = false;
            this.multipleItems = [];
            this.$emit("close");
          });
      }
    },
    acceptAddMultipleEbay() {
      const items = this.multipleItems;
      this.acceptAddMultipleEbayDialog = false;
      //  Create an array of item IDs
      const itemIds = items.map((item) => item._id);
      this.loading = true;
      axios
        .post(
          `${this.baseUrl}/ebay/add-items`,
          { ids: itemIds, institutionId: this.$store.getters.institutionId },
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((response) => {
          this.loading = false;
          this.ebayResponse = response.data;
          this.ebayMultipleDialog = true;
          this.multipleItems = [];
          this.$emit("close");
        })
        .catch((error) => {
          this.loading = false;
          this.multipleItems = [];
          this.alert = {
            value: true,
            type: "error",
            message: "parts.inventory.error_adding_items",
          };
          setTimeout(() => {
            this.alert.value = false;
          }, 5000);
        })
        .finally(() => {
          this.loading = false;
          this.multipleItems = [];
          this.$emit("close");
        });
    },
    removePart(part) {
      this.multipleItems = this.multipleItems.filter((p) => p._id !== part._id);
    },
    cancelEbayMultiple() {
      this.acceptAddMultipleEbayDialog = false;
      this.ebayResponse = null;
      this.multipleItems = [];
    },
    closeAlreadyEbay() {
      this.alreadyOnEbayModal = false;
      this.onEbay = [];
    },
    closeEbayMultiple() {
      this.ebayMultipleDialog = false;
      this.ebayResponse = null;
    },
    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.advanced_search.supply.petrol");
        case "D":
          return this.$t("parts.advanced_search.supply.diesel");
        case "G":
          return this.$t("parts.advanced_search.supply.gas");
        default:
          return supply;
      }
    },
    showActionsErrorModal(msg) {
      this.errorEbayModal = true;
      this.errorMsg = coerceEbayErrorPayload(msg) || msg;
    },
    syncWithEbay() {
      this.loading = true;
      axios
        .post(
          `${this.baseUrl}/ebay/sync-with-ebay`,
          { institutionId: this.$store.getters.institutionId },
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.$emit("close");
        });
    },
    checkKtypes(item) {
      this.kTypesDialog = true;
      this.kTypes = item.infoCar.kTypes;
    },
    closeKtypesDialog() {
      this.kTypesDialog = false;
      this.kTypes = [];
    },
    openEditEbayTitleModal(item) {
      this.itemToEdit = item;
      const title = item.eBayTitle ? item.eBayTitle : "";
      this.qrCode = item.old_id.slice(item._id.length - 6, item.old_id.length);
      if (title) {
        const lastSixChars = title.slice(-6);
        if (lastSixChars === this.qrCode) {
          this.ebayTitle = title.slice(0, -6).trim();
        }
      } else {
        this.ebayTitle = "";
      }
      this.editEbayTitleModal = true;
    },
    openSeeEbayItemsModal(item) {
      this.countriesToShow =
        this.$store.getters.role === "SuperAdmin"
          ? ["it", "es", "fr", "de", "nl", "pl"]
          : ["it", "es", "fr", "de"];
      this.itemTitle =
        item.infoCar &&
        item.infoCar.description &&
        item.infoCar.description.descriptionId &&
        item.infoCar.description.descriptionId.title &&
        item.infoCar.description.descriptionId.title.it &&
        item.infoCar.description.descriptionId.title.it
          ? item.infoCar.description.descriptionId.title.it
          : "";
      this.selectedItem = item;
      if (item.eBayListings && Object.keys(item.eBayListings).length > 0) {
        const filteredListings = {};
        this.countriesToShow.forEach((country) => {
          if (
            item.eBayListings[country] &&
            item.eBayListings[country].length > 0
          ) {
            filteredListings[country] = item.eBayListings[country];
          }
        });
        this.ebayItems = filteredListings;
      } else {
        this.ebayItems = {};
      }
      this.ebayLinksModal = true;
    },
    closeEditEbayTitleDialog() {
      this.editEbayTitleModal = false;
      this.ebayTitle = null;
      this.qrCode = null;
      this.itemToEdit = null;
    },
    acceptEditEbayTitle() {
      this.loading = true;
      const editedTitle = `${this.ebayTitle} ${this.qrCode}`;
      axios
        .put(
          `${this.baseUrl}/part/eBayTitle?id=${this.itemToEdit._id}`,
          { eBayTitle: editedTitle },
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((response) => {
          if (response) {
            if (
              response.data &&
              response.data.ebayError &&
              response.data.ebayError != null
            ) {
              this.showActionsErrorModal(response.data.ebayError);
            } else {
              this.alert = {
                value: true,
                type: "success",
                message: "parts.inventory.ebay_success_title",
              };
              setTimeout(() => {
                this.alert.value = false;
              }, 5000);
            }
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.showActionsErrorModal(err.response.data);
          }
        })
        .finally(() => {
          this.loading = false;
          this.editEbayTitleModal = false;
          this.$emit("close");
        });
    },
    validateInput(event) {
      this.ebayTitle = event.replace(/&/g, "");
    },
    openEbayLink(country, code) {
      const url = `https://www.ebay.${country}/itm/${code}`;
      window.open(url, "_blank");
    },
    getImg(item) {
      switch (item) {
        case "it":
          return "https://portal.lekotech.com/img/icons/ebayIcons/italy.svg";
        case "de":
          return "https://portal.lekotech.com/img/icons/ebayIcons/germany.svg";
        case "es":
          return "https://portal.lekotech.com/img/icons/ebayIcons/spain.svg";
        case "fr":
          return "https://portal.lekotech.com/img/icons/ebayIcons/france.svg";
        case "uk":
          return "https://portal.lekotech.com/img/icons/ebayIcons/united-kingdom.svg";
        case "nl":
          return "https://portal.lekotech.com/img/icons/ebayIcons/netherlands.png";
        default:
          return "";
      }
    },
    closeEbaylinks() {
      this.countriesToShow = [];
      this.ebayLinksModal = false;
      this.selectedItem = null;
      this.ebayItems = {};
      this.$emit("close");
    },
    deleteIndividual(item, countryCode) {
      this.loading = true;
      axios
        .delete(
          `${this.baseUrl}/ebay/delete-single-listing/${this.selectedItem._id}?institutionId=${this.$store.getters.institutionId}&eBayId=${item}&site=${countryCode}`,
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((res) => {
          if (res) {
            this.countriesToShow = [];
            this.ebayLinksModal = false;
            this.selectedItem = null;
            this.ebayItems = {};
            this.alert = {
              value: true,
              type: "success",
              message: "parts.inventory.successfully_removed_ebay",
            };
            setTimeout(() => {
              this.alert.value = false;
            }, 3000);
            this.$emit("close");
          }
        })
        .catch((err) => {
          this.countriesToShow = [];
          this.ebayLinksModal = false;
          this.selectedItem = null;
          this.ebayItems = {};
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.errorMsg
          ) {
            this.errorMsg =
              coerceEbayErrorPayload(err.response.data) ||
              err.response.data.errorMsg;
            this.errorEbayModal = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close");
        });
    },
    deleteAllByCountry(countryCode) {
      this.loading = true;
      axios
        .delete(
          `${this.baseUrl}/ebay/delete-country-listings/${this.selectedItem._id}?institutionId=${this.$store.getters.institutionId}&country=${countryCode}`,
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((res) => {
          if (res) {
            this.countriesToShow = [];
            this.ebayLinksModal = false;
            this.selectedItem = null;
            this.ebayItems = {};
            this.alert = {
              value: true,
              type: "success",
              message: `parts.inventory.successfully_removed_ebay_country_${countryCode}`,
            };
            setTimeout(() => {
              this.alert.value = false;
            }, 3000);
            this.$emit("close");
          }
        })
        .catch((err) => {
          this.countriesToShow = [];
          this.ebayLinksModal = false;
          this.selectedItem = null;
          this.ebayItems = {};
          if (err) {
            this.ebayResponse = err.response.data;
            this.ebayRemoveMultipleDialog = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close");
        });
    },
    deleteAllListings() {
      this.deleteEbayModal = false;
      this.loading = true;
      axios
        .delete(
          `${this.baseUrl}/ebay/delete-all-listings/${this.selectedItem._id}?institutionId=${this.$store.getters.institutionId}`,
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((res) => {
          if (res) {
            this.selectedItem = null;
            this.alert = {
              value: true,
              type: "success",
              message: "parts.inventory.successfully_removed_ebay",
            };
            setTimeout(() => {
              this.alert.value = false;
            }, 3000);
            this.$emit("close");
          }
        })
        .catch((err) => {
          this.selectedItem = null;
          if (err) {
            if (err.response.status === 404) {
              this.alert = {
                value: true,
                type: "error",
                message: "There was an error",
              };
            } else {
              const responseData = err.response.data;

              this.ebayResponse = Array.isArray(responseData)
                ? responseData
                : Object.entries(responseData).map(([key, value]) => ({
                    [key]: value,
                  }));
              this.ebayRemoveMultipleDialog = true;
            }
          }
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close");
        });
    },
  },
};
</script>
<style scoped>
.qr-code-box {
  display: inline-block;
  background-color: #f4f4f4;
  padding: 18px;
  margin-left: -14px;
  border-left: 1px solid #ccc;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  color: #333;
}
.text-error {
  color: red;
}
</style>
